// extracted by mini-css-extract-plugin
export default {"container":"mSSPAz","title":"U4K3yQ","subtitle":"WbNVei","primaryButton":"s1ZZty","secondaryButton":"YvnuX3","mobile":"qhDRBS","buttons":"EwkBl3"};